import React, {Component, PropTypes} from 'react'

export const VotingExtendAge = (props) => <div className='pal-btns-extend'>
  <p>
    Tu nubalsavai už visus klubo narius, pasirink kitą amžiaus grupę arba apsilankyk vėliau!
    <br /><br />
    <a href='javascript:' onClick={() => props.vote(false)} className='underline'>Tęsti žaidimą</a>
  </p>
</div>

export const VotingButtons = (props) => <div className="pal-btns">
  <div className="ui-button-no" onClick={() => props.vote(false)}>{props.nextButtonCaption}</div>
  <div className="ui-button-yes" onClick={() => props.vote(true)}>TAIP</div>
</div>

